import { connect } from 'react-redux'

import List from './List'

import { closeSidebar, setCurrentlyOpenFeature } from 'src/modules/App/actions'

const mapStateToProps = (state) => {
  return {
    currentlyOpenFeature: state.appReducer.currentlyOpenFeature,
  }
}

const mapDispatchToProps = {
  closeSidebar,
  setCurrentlyOpenFeature,
}


export default connect(mapStateToProps, mapDispatchToProps)(List)
